import generateSafeframeAdImpl from './safeframe/generateSafeframeAd';
import generateFriendlyIframeAdImpl from './generateFriendlyIframeAd';
import { track } from '../tracking';
import { withAdResponseReceivedEvent } from '../tracking/events';

var getFcidFromHtml = function getFcidFromHtml(content) {
  var fcidAttributeMatch = content.match(/fcid=['|"]([^']+)['|"]/);
  var hasFcid = fcidAttributeMatch && fcidAttributeMatch.length > 0;
  return hasFcid ? fcidAttributeMatch[1] : undefined;
};

export default (function () {
  var generateSafeframeAd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : generateSafeframeAdImpl;
  var generateFriendlyIframeAd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : generateFriendlyIframeAdImpl;
  var shouldTrackEvent = arguments.length > 2 ? arguments[2] : undefined;
  return function (adSpot, response) {
    var contentType = response.contentType,
        content = response.content,
        isTrustedHtml = response.isTrustedHtml;
    adSpot.nativeType = 'html';
    adSpot.nativeContent = content;

    if (isTrustedHtml) {
      return generateFriendlyIframeAd(adSpot, content);
    }

    var eventProperties = {
      adResponseContentType: contentType,
      fcid: getFcidFromHtml(content)
    };
    track(withAdResponseReceivedEvent(eventProperties), adSpot, shouldTrackEvent);
    return generateSafeframeAd(adSpot);
  };
});
//# sourceMappingURL=createHtmlAdHandler.js.map